import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as commonActions from '@common/common.action';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import RequisicaoCongelacaoContainer from '@common/requisicaoCongelacao/requisicao.congelacao.container';
import IntlMessage from '../../../../../helpers/intlMessage';

class RequisicaoCongelacaoModal extends Component {
  render() {
    return (
      <div className='mv-container-requisicao-congelacao'>
        <Modal size='xl' isOpen={this.props.isOpen} toggle={this.props.toggle}>
          <ModalHeader>
            <IntlMessage id = "dashboards.examDetail.requisitionFreezingReport"/> - {`${this.props.laudo}`}
          </ModalHeader>
          <ModalBody>
            <RequisicaoCongelacaoContainer laudo={this.props.laudo} />
          </ModalBody>
          <ModalFooter>
            <Button
              className='modalComponente-fechar'
              color='secondary'
              onClick={this.props.toggle}
            >
              <IntlMessage id = "dashboards.examDetail.close"/>
            </Button>
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}

const mapDispacthToProps = (dispatch) => {
  return {
    commonActions: bindActionCreators(commonActions, dispatch),
  };
};

export default connect(null, mapDispacthToProps)(RequisicaoCongelacaoModal);



// WEBPACK FOOTER //
// ./src/pages/main/listagem/modais/requisicaocongelacao/requisicao.congelacao.modal.js